import React from 'react'
import styled from 'styled-components'
import useImageLoader from 'hooks/useImageLoader';
import { useDispatch } from 'react-redux' 
import { setViewGallery, setSlideShowIndex  } from 'features/images/imagesSlice';
import { useTranslation } from 'react-i18next'

export default function ImageItem(props) {
    const { t } = useTranslation('media')

    const dispatch = useDispatch()
    const [imageSource, { blur }] = useImageLoader(`${props.image.urlSmall}`, `${props.image.url}`)

    const handleClick = () => { 
        dispatch(setViewGallery(true))
        dispatch(setSlideShowIndex(props.index))
    }

    return (
        <ImageItemContainer
            onClick={handleClick}
            >
            <ChurchImageItem 
                src={imageSource}  
                alt={t('galleryImage')}
                style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    filter: blur ? 'blur(2px)' : 'none',
                    transition: 'all 2s ease-in-out',
                }} 

            /> 
        </ImageItemContainer>
    )
}


const ChurchImageItem = styled.img`
        border-radius: 10px;
        box-shadow: 0px 0px 5px #ccc;

        @media (max-width: 768px) {
            border-radius: 5px;
            aspect-ratio: 4/3;
        }

`   

const ImageItemContainer = styled.div`
    width: 190px;
    height: 150px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s;

    @media (max-width: 768px) {
        width: 45%; 
        margin: 2px;
    }

    &:hover {
        box-shadow: 0px 0px 10px #7d7d7d;
    }

`
